<template lang="pug">
  // li(ref="main", :style="styles")
  router-link(
    tag="div", 
    :to=`{
      name:'portfolio.showcase', 
      params:{
        name:project.title,
        index:project.index
      },
      meta:{
        project:project
      }
    }`
  ).project.project__hoverclass(ref="main", :style="styles")
    .text-area(target="_blank")
      .words.title
        h3.title-text {{project.title}}
      .words.description
        p.desc-text {{project.description}}
</template>

<script>
  export default {
    props:{
      project:Object,
      index:Number,
    },
    data(){
      return {
        scrollY:0,
      }
    },
    computed:{
      styles(){
        // let x = (this.scrollOrigin - this.scrollY)
        // let r = 100;
        // let a = 0;
        // let b = 0;
        // let y = Math.sqrt(r**2 - (x-a)**2) + b
        // let offset = y.toFixed(2);
        return null;
        return {
          backgroundImage:`url('${this.project.image}')`
          // transform:`scale(${offset})`
        }
      },
      scrollOrigin(){
        let el = this.$refs.main
        this.scrollY = el? el.offsetTop : 0;
        return this.$parent.scrollOrigin
      },

    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/css/global";


  @keyframes fadeIn{
    from{
      opacity:0;
    }
    to{
      opacity:1;
    }
  }

  $color: black;
  .smooth{
    // transition:transform 100ms linear;
  }
  .words{

  }
  @include mobile{
    .project{
      border-bottom:2px solid white;
    }
  }

  // .project__hoverclass{
  //     transition: {
  //       duration:400ms;
  //       property: padding, margin, transform;
  //       timing-function:ease-out;
  //     }
  //     transform: scale(1) translateZ(0px);
  //     &:hover{
  //       transform:scale(1.05) translateZ(0px);
  //       z-index: 3;
  //     }
  // }
  
  .project{
    position: relative;
    color:$color;
    width:100%;
    height:20rem;
    // z-index: 2;
    overflow: hidden;

    border-radius: 2px;

    font-size: 2rem;
    background: {
      size:cover;
      position: center;
    }

    border:2px solid black;

    

    // border-bottom:2px solid black;
    // box-shadow: 0 -5px 5px rgba(black, 0.9) inset;
    &:hover{
      // box-shadow: 0 0px 8px rgba(black, 0.5);
    }
    .text-area{
      position: relative;
      background: {
        color:white;
      }
      display: flex;
      justify-content: center;
      align-items: center;

      color:$color;
      width:100%;
      height:100%;

      
      @include mobile{
        width:100%;
      }
      // float:left;
      // border-right:1px solid white;
      // margin-right:3px;
      // text-shadow: 0px -1px 10px rgba($colorE, 0.8);
      .words{
        display: flex;
        justify-content: center;
        align-items: flex-start;
        // z-index:2;
        overflow-x:hidden;
        overflow-y:scroll;
        position: absolute;
        width:95%;
        height:100%;
        // padding:5% 0;
        top:0;bottom:0;left:2.5%;right:2.5%;
      }

      .title, .description {
        .title-text{
          align-self: center;
        }
        .title-text, .desc-text {
          height: auto;
          // height:100%;
          // overflow: scroll;
        }
      }
      img{
        height:10rem;
        transition: box-shadow 250ms ease-in;
        box-shadow: 0 0 4px rgba($colorE, 0.5);
      }
      .transition-text-area{
        transition: {
          property:all;
          duration:1s;
          timing-function:ease;
        }
      }
      transition: {
        property:background-color, color;
        duration:1s;
        timing-function:ease-out;
      }
      @extend .transition-text-area;

      .title{
        @extend .transition-text-area;
        // transition-timing-function: ease-in;
        // transform: translateZ(0%);
        opacity:1;
      }
      .description{
        @extend .transition-text-area;
        // transition-timing-function: ease-out;
        // transform: translateZ(100%);
        opacity: 0;
      }
      &:hover{
        cursor: pointer;
        // text-shadow: 0px -1px 15px rgba($colorE, 0.9);
        text-decoration: none;
        // background-color:black;
        // color:white;
        img{
          box-shadow: 0 0 15px rgba($colorE, 0.7);
        }

        .title{
          opacity: 0;
          // transition-timing-function: ease-out;
          // transform: translateZ(-100%);

          // animation-delay: 250ms;
        }

        .description{
          opacity: 1;
          // transform: translateZ(0%);
          // transition-timing-function: ease-in;
          // animation-delay: 250ms;
        }

      }
    }
  }
</style>


// WEBPACK FOOTER //
// Project.vue?3f7ea700